import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, Compass } from "lucide-react";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import NotFound from "./NotFound";
import { COUNTRIES } from "../data/content";
import { Reveal, usePageMeta } from "../lib/motion";

const CountryDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const country = COUNTRIES.find((c) => c.slug === slug);
  usePageMeta(country ? country.name : "Destination", country?.overview);

  if (!country) return <NotFound />;

  return (
    <main data-testid={`country-page-${country.slug}`}>
      <PageHero eyebrow="DESTINATIONS" title={country.name.toUpperCase()} description={country.blurb} image={country.image} />
      <section className="py-20 lg:py-28 bg-navy-deep">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-3 gap-14">
          <div className="lg:col-span-2">
            <Reveal>
              <h2 className="font-display text-2xl sm:text-3xl font-bold text-white mb-6 tracking-tight">
                Visa assistance for {country.name}
              </h2>
              <p className="text-slate-400 leading-relaxed">{country.overview}</p>
              <p className="mt-4 text-slate-400 leading-relaxed">
                Every application is unique. During your consultation, we review your profile and explain the
                documentation requirements and steps relevant to your chosen pathway.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 flex flex-wrap gap-4">
                <button
                  onClick={() => navigate("/eligibility")}
                  data-testid="country-eligibility-btn"
                  className="btn-gold rounded-full px-8 py-4 text-sm font-bold tracking-wider font-display inline-flex items-center gap-2"
                >
                  CHECK ELIGIBILITY <ArrowRight className="h-4 w-4" />
                </button>
                <button
                  onClick={() => navigate("/countries")}
                  data-testid="country-back-btn"
                  className="btn-outline-light rounded-full px-8 py-4 text-sm font-bold tracking-wider font-display inline-flex items-center gap-2"
                >
                  <ArrowLeft className="h-4 w-4" /> ALL COUNTRIES
                </button>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <aside className="glass-card rounded-2xl p-7 h-fit lg:sticky lg:top-28">
              <div className="flex items-center gap-3 mb-6">
                <img
                  src={`https://flagcdn.com/w80/${country.code}.png`}
                  alt={`${country.name} flag`}
                  className="h-7 w-10 object-cover rounded shadow"
                />
                <h3 className="font-display text-lg font-bold text-white">{country.name}</h3>
              </div>
              <h4 className="font-display text-xs font-bold tracking-[0.25em] text-gold mb-4">POPULAR PATHWAYS</h4>
              <ul className="space-y-2.5">
                {country.pathways.map((p) => (
                  <li key={p} className="flex items-center gap-2.5 text-sm text-slate-300">
                    <Compass className="h-4 w-4 text-gold shrink-0" /> {p}
                  </li>
                ))}
              </ul>
            </aside>
          </Reveal>
        </div>
      </section>
      <CtaBand />
    </main>
  );
};

export default CountryDetail;
